import Immutable from 'immutable';

import sportsReducer from './sportsReducer';
import leaguesReducer from './leaguesReducer';
import matchesReducer from './matchesReducer';
import scoresReducer from './scoresReducer';
import groupsReducer from './groupsReducer';
import outcomesReducer from './outcomesReducer';
// import outcomesHeadersReducer from './outcomesHeadersReducer';
// import outcomesGroupsReducer from './outcomesGroupsReducer';
import matchGroupsReducer from './matchGroupsReducer';
import ratesReducer from './ratesReducer';
import stateReducer from './stateReducer';
import commonStateReducer from './commonStateReducer';
import versionReducer from './versionReducer';
import showLineNumbersReducer from './showLineNumbersReducer';

import * as RepositoryState from 'constants/RepositoryState';

const initialState = Immutable.fromJS({
    sports: {},
    leagues: {},
    matches: {},
    groups: {},
    outcomes: {},
    rates: {},
    scores: {},
    valid: true,
    state: RepositoryState.NOT_INITED,
    showLineNumbers: false,
    version: 0
});

export default function (entities, action, section) {
    if (entities === undefined) {
        return initialState;
    }

    if (action.section !== section) {
        entities = entities.update('state', (s) => commonStateReducer(s, action));
    } else {
        try {
            entities = entities.update('sports', (s) => sportsReducer(s, action));
            entities = entities.update('leagues', (l) => leaguesReducer(l, action));
            entities = entities.update('matches', (m) => matchesReducer(m, action));
            entities = entities.update('showLineNumbers', (flag) => showLineNumbersReducer(flag, action));
            entities = entities.update('scores', (s) => scoresReducer(s, action));

            entities = entities.update('rates', (r) => ratesReducer(r, action));

            entities = entities.update('outcomes', (o) => outcomesReducer(o, action));

            //entities = entities.update('outcomes', (o) =>
            //    outcomesHeadersReducer(action, o, entities.get('matches'), entities.get('rates')));

            // entities = entities.update('outcomes', (o) =>
            //     outcomesGroupsReducer(action, o, entities.get('matches')));

            entities = entities.update('groups', (g) =>
                groupsReducer(g, action, entities.get('outcomes'), entities.get('matches')));

            entities = entities.update('matches', (m) => matchGroupsReducer(action, m, entities.get('groups')));

            entities = entities.update('state', (s) => stateReducer(s, action));
            entities = entities.update('version', (v) => versionReducer(v, action));

            entities = entities.update('valid', () => true);
        } catch (err) {
            //if (process.env.NODE_ENV !== 'production') {
            console.warn('Exception at entitiesReducer');//eslint-disable-line no-console
            console.warn(err);//eslint-disable-line no-console
            //}
            return initialState.set('valid', false);
        }
    }

    return entities;
}



// WEBPACK FOOTER //
// ./js/shared/reducers/entities/entitiesReducer.js